export const HUBS = Object.freeze({
    user: {
        notification: 'NotificationsHub',
        notificationCount: 'OrderStatusNotificationCountHub',
        orderStatusNotificationHub: 'OrderStatusNotificationHub'
    },
    outbound: {
        good: {
            validation: 'FileValidation/CustomerDeliveryGoodPartsUploadHub',
            submit: 'SubmitOrders/CustomerDeliveryGoodPartsUploadHub'
        },
        defective: {
            validation:
                'FileValidation/ReturnPartsDefectiveFromChoiceUploadHub',
            submit: 'SubmitOrders/ReturnPartsDefectiveFromChoiceUploadHub'
        }
    },
    inbound: {
        good: {
            validation: 'FileValidation/ReplenishmentsGoodPartsUploadHub',
            submit: 'SubmitOrders/ReplenishmentsGoodPartsUploadHub'
        },
        defective: {
            validation: 'FileValidation/ReturnPartsDefectiveToChoiceUploadHub',
            submit: 'SubmitOrders/ReturnPartsDefectiveToChoiceUploadHub'
        }
    },
    transfers: {
        good: {
            validation: 'FileValidation/WarehouseTransfersGoodPartsUploadHub',
            submit: 'SubmitOrders/WarehouseTransfersGoodPartsUploadHub'
        },
        defective: {
            validation:
                'FileValidation/WarehouseTransfersDefectivePartsUploadHub',
            submit: 'SubmitOrders/WarehouseTransfersDefectivePartsUploadHub'
        }
    }
});

export enum RECEIVE_EVENTS {
    RECEIVE_UNREAD_ORDER_STATUS_NOTIFICATIONS_COUNT = 'ReceiveUnreadOrderStatusNotificationCount',
    RECEIVE_ORDER_STATUS_NOTIFICATION = 'ReceiveOrderStatusNotification',
    RECEIVE_SUBMISSION = 'ReceiveSubmissionProgress',
    RECEIVE_FILE_VALIDATION = 'ReceiveFileValidationProgress',
    RECEIVE_USER_STATUS = 'ReceiveUserStatusMessage'
}
